<template>
  <div id="tPayContainer">
    <component
      v-if="loader === false"
      @changePage="changePage"
      :is="errorCode ? navigator.ERROR : currentPage"
      :errorCode="errorCode"
      :orders="orders"
      :paymentType="paymentType"
      :uuidGets="uuidGets"
      @startLoader="startLoader"
      :onRefresh="onRefresh"
      :isCheck="isCheck"
      :nameTheme="nameTheme"
      :companyConfig="companyConfig"
      :isActiveMenu="isActiveMenu"
      :isActivewaiter="isActivewaiter"
      :isActiveReviews="isActiveReviews"
      :workTime="workTime"
      :hallId="hallId"
      :tradepointId="tradepointId"
      :tableId="tableId"
      :isWaiterWasCall="isWaiterWasCall"
      :linkMenu="linkMenu"
      :useWorkTime="useWorkTime"
      @updateForUpdateOpenPage="updateForUpdateOpenPage"
      :isWithoutPay="isWithoutPay"
      :phoneNumber="phoneNumber"
      :goToStartPage="goToStartPage"
      :contacts="contacts"
    />
    <loader v-if="loader"></loader>
  </div>
</template>

<script>
//Оголошуємо глобально websocket
var socket;
import Vue from "vue";
import Loader from "@/components/Loader.vue";
import { joinCityAddress } from "@/utils/address";
import axios from "axios";
import VueAxios from "vue-axios";
import { Start, GetOrders } from "@/components/API.js";

import { store } from "@/store.js";

// import ReconnectingWebSocket from 'reconnecting-websocket';
import SelectCheck from "./selectCheck.vue";
import { initializationLang } from "../lang/init";
import { routes_components, navigator } from "./configRoutes";

import { connectTypaySocket, sendSocketTypayGuest } from "./tpayConnect";

let apiStart = new Start();
let apiGetorder = new GetOrders();

Vue.use(VueAxios, axios);

const getCurentPage = () => {
  const params = new URLSearchParams(window.location.search);
  const skyservicePage = params.get("skyservice");
  switch (skyservicePage) {
    case "pay":
      return navigator.ORDERS;
    case "reviews":
      return navigator.REVIEWS;
    case "terms":
      return navigator.TERMS;
    default:
      return navigator.START_PAGE;
  }
};

export default {
  name: "tPay",
  data() {
    return {
      currentPage: getCurentPage(),
      //Мова за замовчуванням
      lang: "en",
      // isPayments: false, для успешной оплаты
      nameTheme: "",
      paymens: [],
      orders: [], //Список замовлень
      isCheck: false, // темплейты!    Выбор между типом чеков

      tPayId: null, // if null Error Page
      isErrorPay: false, // Помилка про оплату яку передаю з термынал Page
      socketError: false, // Стан помилки сокета  Page
      socketErrorStatus: null, // Статус який отримую з сокету Page
      workTime: null,
      isActiveMenu: false, // блок активації меню
      isActivewaiter: false, // блок активації виклику офіціанта
      isActiveReviews: false, // блок активації відгуків

      hallId: null, // id Залу для виклику офіціанта
      tradepointId: null, // id Торгової для виклику офіціанта
      tableId: null, // id Столу для виклику офіціанта
      linkMenu: null,

      forUpdateOpenPage: null,
      isWithoutPay: false, //Відповідає чи показувати блок опати, якщо вибрали "без оплати"
      phoneNumber: false, // номер телефону закладу
      contacts: "",

      isWaiterWasCall: false, //Підтвердження виклику, зникаюче

      //Спінер
      loader: true,
      //Або liqpay або portmone
      paymentType: null,
      uuidGets: null,
      //Параметри компанії
      companyConfig: {
        companyLogo: null,
        companyName: null,
        logoStartPage: null,
      },
      //Параметри конфігурації для модулю VuePullRefresh

      //Створено для того щоб можна було зупинити очікування відповіді від терміналів
      timeoutSpinerObj: null,

      isWasError: false, // Помилка 1001
    };
  },
  components: {
    Loader,
    SelectCheck,
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      const url = new URL(window.location.href);
      switch (page) {
        case navigator.REVIEWS:
          url.searchParams.set("skyservice", "reviews");
          window.history.pushState(null, "", url.toString());
          break;
        // case navigator.REVIEWS: window.location.href = window.location.href + '&skyservice=reviews'; break;
      }
    },
    // Перехід назад
    goToStartPage() {
      if (this.isActiveMenu || this.isActivewaiter) {
        let url = new URL(window.location.href);

        if (url.searchParams.has("skyservice")) {
          url.searchParams.delete("skyservice");
          window.history.replaceState(null, null, url.toString());
        }

        this.currentPage = navigator.START_PAGE;
      }
    },
    // Початок роботи спінера
    startLoader() {
      this.loader = true;
      this.timeoutSpiner();
    },
    updateForUpdateOpenPage(pageName) {
      this.forUpdateOpenPage = pageName;
    },
    // Можливо потрібно буде
    // checkResultPayment(message) {
    //   const currentOrder = this.orders.find(or => or.id === message.id);
    //   if (!currentOrder) return;
    //   this.orders = this.orders.map((elem) => {
    //     if (elem.id === message.id) {
    //       elem.succseseful = true;
    //     }
    //     return elem
    //   })
    //   // this.isPayments = true;

    //   const order = {
    //     sum: currentOrder.sum,
    //     id: currentOrder.id
    //   }

    //   this.paymens.push(order)
    //   setTimeout(() => {
    //     this.paymens = this.paymens.filter((or) => or.id !== order.id)
    //     // this.paymens.length === 0 && (this.isPayments = false)
    //   }, 10000)
    // },
    // Помилка якщо термінал офлайн
    handleSocketError(is, socketErrorStatus) {
      this.socketError = is; // Оновлюємо стан помилки
      // Якщо помилка то видаляємо всі замовлення
      // callWaiter
      if (is) {
        this.orders = [];
        this.isWasError = true;
        this.socketErrorStatus = +socketErrorStatus;
        if (window.socketType === "callWaiter")
          this.currentPage = navigator.ORDERS; // якщо виникає помтлка переходимо на помилку 1001
      }
    },
    //Отримати/Оновити список замовлень
    onRefresh() {
      //Очищаем список замовлень на экрані
      // this.orders = [];
      //Надсилаємо запит на отримання замовлень з активних терміналів
      if (document.body.children[1]?.scrollTop > 50) return;
      this.startLoader();
      const messageSend = {
        qrToken: `${store.tpayId}`,
        action: "getOrders",
      };

      sendSocketTypayGuest(messageSend);
      this.isErrorPay = false;
      this.socketError = false;
      this.socketErrorStatus = null;
    },
    changeTheme(data, isSwipe) {
      const bodyStyles = document.body.style;
      for (const key in data) {
        if (key === "name") continue;
        const color = data[key];
        const arr = key.split("_");
        const newArr = arr.map((name, i) => (i ? "-" + name : "--" + name));
        const keyForCss = newArr.join("");
        bodyStyles.setProperty(keyForCss, color);
      }
      // Перевірка для відступу знизу закрашування
      bodyStyles.setProperty("--app-bg", isSwipe ? data.footer : data.content);
    },
    // Стартовий запит
    getStart() {
      return apiStart
        .getStart()
        .then((response) => response.data)
        .catch((error) => error);
    },
    timeoutSpiner(timeout = 5000) {
      //Та очікуємо відповідь 5 секунд
      this.timeoutSpinerObj = setTimeout(() => {
        if (this.loader) {
          //Приховуємо спінер
          this.loader = false;
        }
      }, timeout);
    },
    //Створення Invoice
    payInvoice(orderId) {
      socket.send(
        JSON.stringify({
          send: "createInvoice",
          payment: {
            paymentSystem: this.paymentType,
            invoice: { id: orderId },
          },
        })
      );
      //отправляем через вебсокет на терминал
    },
  },
  created() {
    routes_components.forEach((elem) =>
      Vue.component(elem.name, elem.component)
    );

    this.startLoader();
  },
  computed: {
    navigator() {
      return navigator;
    },
    errorCode() {
      // Сторінки, які не залежать від наявності замовлень. На них не можна
      // показувати ані «немає чеків», ані втрату зв'язку з терміналом:
      // юридичний розділ має лишатись доступним завжди, інакше перевірка
      // LiqPay його просто не побачить.
      const isOrderlessPage = [
        navigator.START_PAGE,
        navigator.REVIEWS,
        navigator.TERMS,
      ].includes(this.currentPage);
      if (this.tPayId === null) return 404; // tPayId не был найден
      if (this.isErrorPay) return 410; // isErrorPay Не прошла оплата
      if (this.socketError && this.socketErrorStatus) {
        switch (+this.socketErrorStatus) {
          case 1001:
            if (!isOrderlessPage) return 1001;
            break;
          case 1002:
            return 1002;
        }
      } //помилка 1001 сокет
      if (this.orders.length == 0 && !isOrderlessPage) return 400; // Нету чеков для оплаты
      return false;
    },
  },

  mounted() {
    if (store.tpayId) {
      this.tPayId = store.tpayId;
      //API з якого отримуємо налаштування сторінки. Лого, найменування та мову
      this.getStart().then((data) => {
        initializationLang(data?.defaultLang);
        this.companyConfig.companyLogo = data?.companyLogo;
        this.companyConfig.companyName = data?.companyName;
        this.companyConfig.logoStartPage = data?.logoStartPage;
        store.companyName = data?.companyName;
        // this.lang = data.defaultLang;
        this.changeTheme(data?.styleWeB, data?.isSwipe);
        this.nameTheme = data?.styleWeB?.name;
        store.companyId = data?.companyId;
        store.activePaymentSystem = data?.activePaymentSystem;
        // Юридичні відомості продавця для розділу «Оплата і повернення».
        store.company = data?.companySettings || null;
        store.terms = data?.terms || null;
        this.hallId = data?.hallId; // id Залу для виклику офіціанта
        (this.tradepointId = data?.tradepointId), // id Торгової для виклику офіціанта
          (this.tableId = data?.tableId); // id Столу для виклику офіціанта
        this.workTime = data?.tradepoint?.workTime;
        this.useWorkTime = data?.tradepoint?.useWorkTime;
        this.linkMenu = data?.linkMenu;
        this.isWithoutPay = data?.withoutPay;
        this.phoneNumber = data?.tradepoint?.contacts?.phone;
        this.contacts = joinCityAddress(
          data?.tradepoint?.contacts?.city,
          data?.tradepoint?.contacts?.address
        );

        store.address = data?.tradepoint?.contacts?.address;
        // -----
        // const isPayment = params.get('skyservice');
        // console.log(isPayment, 'skyservice')
        // if (isPayment !== 'pay') {
        this.isActiveMenu = data?.isActiveMenu;
        this.isActivewaiter = data?.isActiveWaiter;
        this.isActiveReviews = data?.isActiveReviews;

        // }

        this.isCheck = data?.isSwipe; // Відповідає що малювати або свайп або скрол
        //Підключаємось до Websocket

        if (!data.isActiveWaiter && !data.isActiveMenu)
          this.currentPage = navigator.ORDERS;
        const handleTPayMessage = (response) => {
          const res = JSON.parse(response.body);
          const ress = JSON.parse(res);
          switch (ress.type) {
            case "sendOrders": {
              const orderIds = ress.orderIds;
              Promise.all(orderIds.map((id) => apiGetorder.getorder(id)))
                .then((response) => {
                  const orders = response
                    .filter((res) => res.status === "done")
                    .map((e) => e.data);
                  this.paymentType = ress.paymentType;
                  this.uuidGets = ress.uuidGuest;
                  // this.orders = orders;
                  // Костиль роботи з двума касами
                  // Перевіряємо та додаємо лише унікальні замовлення
                  this.orders = [
                    ...orders,
                    ...this.orders.filter(
                      (order) => !orders.some((o) => o.id === order.id)
                    ),
                  ];
                  // this.orders = [
                  //   ...this.orders,
                  //   ...orders.filter(order => !this.orders.some(o => o.id === order.id))
                  // ];

                  // Відпрацьовує при рефшері, якщо при рефреші нам потрібно перейти на сторінку, то ми записуємо цб сторінку в forUpdateOpenPage
                  if (this.forUpdateOpenPage) {
                    this.currentPage = this.forUpdateOpenPage;
                    this.forUpdateOpenPage = null;
                  }
                })
                .finally(() => (this.loader = false));

              //! place
              break;
            }
            case "updateOrder": {
              // Костиль якщо щось не летить то відправляємо повідомлення заново
              if (
                this.paymentType == null ||
                this.uuidGets == null ||
                this.isWasError
              ) {
                this.isWasError = false;
                this.onRefresh();
              }

              const orderId = ress.orderId;
              apiGetorder
                .getorder(orderId)
                .then((response) => {
                  const order = response.data;

                  if (order) {
                    const orderOne = {
                      sum: order.sum,
                      id: order.id,
                      localId: order.localId,
                      comment: order.comment,
                      companyId: order.companyId,
                      okruglenie: order.okruglenie,
                      discountSum: order.discountSum,
                      //  "table": order.table,
                      table: order?.checkout?.table?.tableId || order?.table,
                      // "table": order.checkout.table.tableId,
                      products: order?.checkout?.products || order?.products,
                      // products: order.products
                      prepaymentData: order.prepaymentData,
                    };
                    this.isErrorPay = false;

                    const orderIndex = this.orders.findIndex(
                      (e) => e.id === orderOne.id
                    );
                    if (orderIndex === -1) this.orders.push(orderOne);
                    else this.orders[orderIndex] = orderOne;
                    this.orders = [...this.orders];
                  }
                })
                .finally(() => (this.loader = false));
              break;
            }
            case "createInvoice": {
              this.paymentType = ress.paymentType;
              this.uuidGets = ress.uuidGuest;
              const orders = ress.data || []; // Отримуємо список замовлень з об'єкта даних
              this.orders = orders; // Оновлюємо дані замовлень у власності Vue компонента
              this.loader = false;
              this.isErrorPay = false;

              this.startLoader();

              location.replace(ress.payment.invoice.link);
              break;
            }
            case "removeOrder": {
              this.orders = this.orders.filter(({ id }) => ress.orderId !== id);
              break;
            }
            case "errorPay": {
              this.handleSocketError(true, null);
              this.isErrorPay = true;
              break;
            }
            case "callWaiterResult":
              this.isWaiterWasCall = true;
              setTimeout(() => (this.isWaiterWasCall = false), 20000);
          }
        };

        // const errorCallback = (r) => console.log(r) // может пропасть this
        connectTypaySocket(handleTPayMessage, this.handleSocketError); // Нужно добавитт парс
      });
    } else {
      this.loader = false;
    }
  },
};
</script>

<style>
.pull-down-header {
  background: var(--app-bg) !important;
}

p {
  margin: 0 !important;
}

#tPayContainer {
  width: 100%;
  background: #fff;
  background: var(--content) !important;
  color: var(--text-content) !important;

  display: flex;
  flex-direction: column;
}

.title_Eror {
  font-weight: bold;
  font-size: 25px;
}

.swip-g {
  overflow: hidden;
  height: 100%;
  /* height: calc(100vh - 95px); */
  width: 100%;
}

.headerContainer {
  width: 100%;
  height: 75px;
  min-height: 75px;
  display: flex;
  background: var(--head) !important;
  color: var(--text-head) !important;
}

.nameContainer {
  padding-top: 22px;
  padding-left: 10px;
  font-size: 13pt;
}

.logoContainer {
  height: 45px;
  border-radius: 9999px;
}

.urlLogo {
  height: 45px;
  margin-top: 10px;
  margin-left: 30px;
}

.contentContainer {
  /* position: fixed;
  top: 0;
  left: 0; */
  /* width: 100%; */
  /* height: calc(100% - 110px); */
  padding: 10px;
  width: 100%;
  /* height: calc(100vh - 110px);
  height: calc(100vh - 160px); */
  /* overflow-y: scroll; */
  /* background: var(--content-color) !important; */
  background: var(--app-bg) !important;
}

.receiptsNotFound {
  /* width: 100%;
  text-align: center;
  position: fixed;
  top: calc(50% - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  color: var(--text-head) !important; */

  width: 100%;
  height: 100vh;
  /* Встановлює висоту блоку на весь екран */
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  text-align: center;
  color: var(--text-head) !important;
  background: var(--app-bg) !important;
}

.footerContainer {
  width: 100%;
  height: 20px;
  min-height: 20px;
  /* Типографіка та сама, що у футері StartPage.vue і Reviews.vue: рядок
     «Powered by» має виглядати однаково на всіх екранах. */
  font-family: "Manrope", serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  margin-top: -10px;
  /* position: absolute; */
  /* bottom: 0; */
  color: var(--text-content) !important;
  /* background: var(--footer-color) !important; */
  background: var(--content) !important;
  /* position: fixed; */
  /* bottom: 0; */
  /* top: calc(100% - 20px); */
}

.footerContainerSize {
  width: 100%;
  height: 20px;
  min-height: 20px;
  background-color: transparent;
}

/* Саме `> span a`, а не будь-яке посилання у смузі: поруч живе ще
   «Умови користування», і жирність із підкресленням до нього не стосуються. */
.footerContainer > span a {
  color: var(--text-content) !important;
  /* Як на стартовій: назва напівжирна й без підкреслення. Там це дає
     `a { all: unset }` у скоупі сторінки, тут виставляємо явно. */
  font-weight: 700;
  text-decoration: none;
  /* Як на стартовій і у відгуках. */
  transition: opacity 0.2s ease;
}

.footerContainer > span a:hover {
  color: var(--text-content) !important;
  opacity: 0.8;
}

.orders {
  display: flex;
  width: 100%;
  /* flex-wrap: wrap; */
  justify-content: flex-start;

  flex-direction: column;
  align-items: flex-start;
  padding: 10px 15px;
  /* overflow: hidden;
  overflow: auto; */
  /* height: calc(100vh - 160px);
  height: calc(100vh - 180px); */
}

.order {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  border-radius: 16px;
  min-width: 22%;
  /* margin-bottom: 20px; */
  position: relative;
  background: var(--innerBody) !important;
}

.order-top {
  color: var(--text-innerBody) !important;
}

.order__number {
  text-align: center;
  font-size: 16pt;
  font-weight: bold;
}

hr {
  margin-top: 0;
  background: rgba(255, 255, 255, 0.2) !important;
}

hr.between-goods {
  margin: 0;
}

.order__sale {
  font-size: 20px !important;
  height: 60px;
  width: 100%;
  border-radius: 0 0 15px 15px !important;
  outline: 0 !important;
}

.btn-primary {
  background: var(--button) !important;
  border-color: var(--button) !important;
  color: var(--text-button) !important;
  /* font-weight: bold !important; */
}

.headerText {
  font-size: 1rem;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 600px) {
  .order {
    min-width: 100%;
  }
}
</style>
